import {Injectable} from '@angular/core';
import {Tab} from './tab.model';
import {BehaviorSubject} from 'rxjs';
import {forEach} from '@angular/router/src/utils/collection';
import {Observable} from 'rxjs/index';


//this assumes that there will be only one tab component initialised

@Injectable()
export class TabService {

  tabChangeEvent: BehaviorSubject<Tab>;

  // initialise the tab array separately;
  allTabs: Tab[];

  constructor() {
  }


  initialiseService() {
    this.tabChangeEvent = new BehaviorSubject<Tab>(undefined);
  }

  getTabs(tabs: Tab[]) {
    if (!tabs || !tabs.length) {
      return [];
    }
    if (this.checkDuplicateKeys(this.getKeysFromTabsObject(tabs))) {
      throw new Error('Duplicate keys in tab array');
    }
    return tabs;
  }

  checkDuplicateKeys(values: string[]) {
    return values.some((value, index) => {
      return values.slice(index + 1, values.length).indexOf(value) !== -1;
    });
  }

  getKeysFromTabsObject(tabs: Tab[]) {
    return tabs.map((obj) => obj.key);
  }

  getTabChangeEventSubject() {
    return this.tabChangeEvent;
  }

  updateTabSelection(selectedTab: Tab) {
    this.tabChangeEvent.next(selectedTab);
  }

}
